import { computed, unref, useContext, useRoute } from '@nuxtjs/composition-api'
import { MaybeRef } from '@vueuse/core'

import Store from '@/classes/Store'
import HertzStore from '@/classes/Hertz/HertzStore'

export default function (store: MaybeRef<Store | null>) {
  const { query, localePath } = useContext()

  return computed(() => {
    const link = unref(store)?.storeLink

    if (!link) return
    return localePath({
      path: link,
      query: query.value,
    })
  })
}

export function useHertzStoreLink (rentOrReturn: string, store: MaybeRef<HertzStore | null>) {
  const route = useRoute()
  const { query, localePath } = useContext()

  /**
   * confirm 頁需透過 query 取得 locationCode
   * search 頁則是透過 store 獲取
   * */
  const rentStore = rentOrReturn === 'rent' ? unref(store)?.locationCode || unref(query)?.startLocation : unref(store)?.endLocationCode || unref(query)?.endLocation

  const vendor = unref(store)?.vendor ? unref(store)?.vendor : unref(route).params.vendor

  return computed(() => {
    const link = `/car/store_hertz/${vendor}/${rentStore}`
    if (!link) return
    return localePath({
      path: link,
      query: query.value,
    })
  })
}
